import { HotCard } from "components";
import { Swiper, SwiperSlide } from "swiper/react";

export default function Hot({ className }) {
  const hotList = [
    {
      id: 1,
      image: "/images/hot-1.png",
      title: "Get 10% off on return ticket",
      duration: "1st Nov - 31 Dec 2024",
      originalRm: "40.00",
      discountRm: "36.00",
      isHot: false,
    },
    {
      id: 2,
      image: "/images/hot-2.png",
      title: "Get 10% off on return ticket",
      duration: "1st Nov - 31 Dec 2024",
      originalRm: "5.00",
      discountRm: "10.00",
      isHot: false,
    },
    {
      id: 3,
      image: "/images/hot-3.png",
      title: "Let’s Get Saleford Potato today",
      duration: "1st Nov - 31 Dec 2024",
      originalRm: "20.00",
      discountRm: "30.00",
      isHot: false,
    },
  ];

  return (
    <div className={`w-full mb-[40px] md:mb-[60px] ${className}`}>
      <div className="w-full flex items-center mb-5 md:mb-6 lg:mb-3">
        <div className="flex-1 text-base md:text-[32px] lg:leading-8 font-semibold text-black">
          What’s hot
        </div>
        <button className="text-[12px] font-semibold text-primary-700 block lg:hidden">
          View All
        </button>
      </div>

      <div className="text-base text-[#112211] mb-10 hidden lg:block">
        Lorem ipsum is a placeholder text commonly used to demonstrate.
      </div>

      <div className="w-full flex">
        <Swiper
          slidesPerView={1.5}
          spaceBetween={18}
          style={{ width: "100%" }}
          breakpoints={{
            380: {
              slidesPerView: 1.5,
            },
            420: {
              slidesPerView: 2.2,
            },
            980: {
              slidesPerView: 3,
            },
          }}
        >
          {hotList.map((item, index) => (
            <SwiperSlide key={index}>
              <HotCard key={index} data={item} showContent={false} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
